import React, { ReactElement } from 'react'
import Prepare from './Prepare'
import InstanceControl from './InstanceControl'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { buildLogLink, currentCommitLabel, currentCommitLink, hasBuildTimestamp } from '../helpers/environment'
import { faToggleOn, faToggleOff, faPowerOff, faPlug } from '@fortawesome/free-solid-svg-icons'
import { currentBuildTimestamp } from '../helpers/environment'
import ApiLog from './ApiLog'

library.add(faToggleOn, faToggleOff, faPowerOff, faPlug)

const Admin = (): ReactElement => {
    return <>
        <h2>Administration</h2>

        <div className="thumbnail-list settings-thumbnail-list admin-thumbnail-list">

            <Prepare admin={ true } />

            <div className="thumbnail thumbnail-static">
                <div className="tip">
                    Current app version: <a href={ currentCommitLink() }>
                        {currentCommitLabel()}
                        <FontAwesomeIcon className="external-link" icon="external-link-alt" />
                    </a>
                    { hasBuildTimestamp() && <>, built on <a href={ buildLogLink() }>
                        {currentBuildTimestamp(true)}
                        <FontAwesomeIcon className="external-link" icon="external-link-alt" />
                    </a>.
                    </> }
                </div>
            </div>

            { (['diary_production', 'diary_flash_db', 'diary_flash', 'fac_legacy'] as const)
                .map(instanceId =>
                    <InstanceControl key={ instanceId } instanceId={ instanceId } />)
            }

            <div className="thumbnail thumbnail-static">
                <h3>User administration</h3>
                Use the <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://manage.auth0.com/dashboard/eu/diary-processing/users">
                    Auth0 page<FontAwesomeIcon className="external-link" icon="external-link-alt" />
                </a>.
            </div>

            <ApiLog />

        </div>
    </>
}

export default Admin
